import React from 'react';
import {Stack} from '@mui/material';
import TextSegment from './TextSegment';
import HtmlSegmentView from './HtmlSegmentView';

/**
 * Renders a list of segments in either text or HTML view mode
 */
const SegmentList = React.memo(({
                                    viewMode,
                                    htmlSegments,
                                    displaySegments,
                                    highlightsBySegment,
                                    entitiesMap,
                                    effectiveQuery,
                                    onEntityClick
                                }) => {
    return (
        <Stack p={4} pt={2}>
            {viewMode === 'html' && htmlSegments ? (
                htmlSegments.map((segmentData, index) => {
                    const rawHtml = segmentData?.rawHtml || '';
                    const entities = segmentData?.entities || [];
                    const rangesRaw = highlightsBySegment.get(index) || [];

                    let highlightType = null;
                    let highlightLabel = null;

                    if (rangesRaw.length > 0) {
                        const segmentTextLength = segmentData?.content?.length || 0;
                        for (const r of rangesRaw) {
                            const coversFullSegment =
                                r.startIndex === r.endIndex &&
                                r.startIndex === index &&
                                r.startOffset === 0 &&
                                (r.endOffset >= segmentTextLength * 0.95 || r.endOffset === 0);

                            if (coversFullSegment) {
                                if (!highlightType || (r.type === 'cited' && highlightType !== 'cited')) {
                                    highlightType = r.type;
                                    highlightLabel = r.labelText;
                                }
                            }
                        }
                    }

                    return (
                        <HtmlSegmentView
                            key={`segment-${index}`}
                            index={index}
                            rawHtml={rawHtml}
                            entities={entities}
                            onEntityClick={onEntityClick}
                            highlightType={highlightType}
                            highlightLabel={highlightLabel}
                        />
                    );
                })
            ) : (
                displaySegments.map((segmentData, index) => {
                    const content = typeof segmentData === 'string'
                        ? segmentData
                        : (segmentData?.content || '');
                    return (
                        <TextSegment
                            key={`segment-${index}`}
                            index={index}
                            content={content}
                            segmentData={segmentData}
                            highlightsBySegment={highlightsBySegment}
                            entitiesMap={entitiesMap}
                            effectiveQuery={effectiveQuery}
                            onEntityClick={onEntityClick}
                        />
                    );
                })
            )}
        </Stack>
    );
});

export default SegmentList;
